import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungWolfsburg() {
  return (
    <CityPageTemplate
      city="Wolfsburg"
      slug="wolfsburg"
      intro="In der Autostadt Wolfsburg lohnt es sich, nicht nur in Fahrzeuge zu investieren – wir zeigen Dir wie."
      description="Unabhängige & digitale Finanzberatung für Wolfsburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
